export default () => ({
    loader: {
        color: '#fff'
    },
    unpauseButton: {
        minWidth: 200
    }
});
